import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import type { IAugmentedBackendResponse } from '../models/IAugmentedBackendResponse';
import type { ISortingMeta } from '../models/ISortingMeta';
import type { ISignUpRequestDetail, ISignUpRequestUpdate } from '../models/SignUpRequestDetail';
import type { TPandasTable } from '../models/TPandasTable';
import { type UpdateInfoPayload } from '../models/UserAccountModel';
import CoreJsonAPIService from './CoreJsonAPIService';
import { type EUserRoles } from '../enums/EUserRoles';

export default class SvUserManagementCoreService extends CoreJsonAPIService {
  static async getAllSignUpRequests(params: { page: number; sorting: ISortingMeta; search?: string }) {
    return await super.get<IAugmentedBackendResponse<TPandasTable>>(EDjangoAppsEndpoints.userManagement, 'sign-up', {
      page: params.page,
      sortCol: params.sorting.sortCol,
      ascending: params.sorting.ascending,
      searchText: params.search ?? ''
    });
  }

  static async getSingleRequest(id: string) {
    return await super.get<ISignUpRequestDetail>(EDjangoAppsEndpoints.userManagement, `sign-up/${id}`);
  }

  static async updateSignUpRequest(id: string, body: ISignUpRequestUpdate) {
    return await super.put<ISignUpRequestDetail>(EDjangoAppsEndpoints.userManagement, `sign-up/${id}`, body);
  }

  static async deleteSignUpRequest(id: string) {
    return await super.delete<boolean>(EDjangoAppsEndpoints.userManagement, `sign-up/${id}`);
  }

  static async getUserDetails(id: string) {
    return await super.get<{
      firstName: string;
      lastName: string;
      email: string;
      roles: EUserRoles[];
    }>(EDjangoAppsEndpoints.userManagement, `admin/user/${id}`);
  }

  static async updateUserDetails(id: string, body: Partial<UpdateInfoPayload>) {
    return await super.put<{
      firstName: string;
      lastName: string;
      email: string;
      roles: EUserRoles[];
    }>(EDjangoAppsEndpoints.userManagement, `admin/user/${id}`, body);
  }
}

